import controller from './facture-x-progress-modal.controller';
import template from './facture-x-progress-modal.tpl.html';

export default {
	bindings: {
		modalInstance: '=',
		resolve: '='
	},
	template,
	controller
};
